import React from 'react';
import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';

class Multiscatter extends React.Component {
    constructor() {
        super();
        this.state = { 
            learningrate: null, 
            iterations: null, 
            r2: true, 
            scatter: true, 
            equation: true,
            methodology: null,
            error: true,
            values: []
             }
    }
    _onClick(output) {
        //this.props.onSubmit()
        this.props.onSubmit(output)
    }

    _onChange(field, event) {
        const {r2, scatter, equation} = this.state
        let splitted;
        if (field.includes("var")) {
            splitted = parseInt(field.split("r")[1]) - 1
            let newValue = this.state.values
            newValue[splitted] = event.target.value;
            this.setState({ values: newValue})
        } else {
            switch(field) {
                case "learningrate":
                    this.setState({ learningrate: event.target.value})
                    break;
                case "iterations":
                    this.setState({ iterations: event.target.value })
                    break;
                case "r2":
                    this.setState({ r2: !r2 })
                    break;
                case "scatter":
                    this.setState({ scatter: !scatter })
                    break;
                case "equation":
                    this.setState({ equation: !equation })
                    break;
                case "error":
                    this.setState({ error: event.target.value })
                    break;
            }
        }
    }
    render() {
        //let { topvalue, bottomvalue,rotate,stack,barcolor,columnwidth,title, legends, exprt } = this.state
        const {methodology, learningrate, iterations, r2, scatter, equation, error, values} = this.state
        const output = {methodology, learningrate, iterations, r2, scatter, equation, error, values}

        return (
            <div>
                <div>
                <h2><strong>Chose Options</strong></h2>
                <Box direction='row'
                        justify='center'
                        align='center'
                        wrap={true}
                        reverse={false}
                        margin='none'>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <CheckBox 
                                name='r2'
                                id='r2'
                                label='Show R2'
                                toggle={true}
                                disabled={false}
                                reverse={true}
                                defaultChecked={true}
                                onChange={this._onChange.bind(this, 'r2')}/>
                        </Box>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <CheckBox 
                                name='equation'
                                id='equation'
                                label='Equation'
                                toggle={true}
                                disabled={false}
                                reverse={true}
                                defaultChecked={true}
                                onChange={this._onChange.bind(this, 'equation')}/>
                        </Box><br/>
                
                
                    </Box>
                <Button label='Submit'
            type='submit'
            primary={true}
            onClick={this._onClick.bind(this, output)} />
                </div> 
            </div>  
        );
    }
}

export default Multiscatter;



// WEBPACK FOOTER //
// ./src/samples/options/multiscatter.js